import {ANY_EVENT, FIRST_EVENT} from '../models/constants';
import {ConditionTab} from '../models/enums/builder-enums';

export {
  commaizeNumber,
  extend,
  isDefinedValue,
  objToQueryString,
  parseUrlQueryParams,
  pluralize,
  sorted,
  truncateMiddle,
} from '../../../util';

export {
  getIconForEvent,
  getIconForPropertyType,
  renameEvent,
  renameProperty,
  updatePropertyValueMappings,
  renamePropertyValue,
} from '../../../report/util';

export {insertAtIndex, removeByIndex, removeByValue, replaceByIndex} from '../../../util/array';

export {formatDate, parseDate, relativeToAbsoluteDate} from '../../../util/date';

export {countSymbols, stringFilterMatches} from '../../../util/string';

export {eventWasOutside} from '../../../util/dom';

export {getLabelParts, isCohortLiteral, isEventLiteral, isPeopleLiteral} from './staged-cohort';

export {closestEl} from './dragging';

import {renameEvent} from '../../../report/util';

interface CustomEvent {
  custom: boolean;
  deleted: number;
  id: number;
  is_collect_everything_event: boolean;
  name: string;
}

export const isCustomEvent = (eventName: string): boolean => {
  return eventName.startsWith(`$custom_event:`);
};

export const displayNameForBehaviorEvent = (eventName: string, customEvents: CustomEvent[]): string => {
  let name;
  if (isCustomEvent(eventName)) {
    const customEventID = Number(eventName.slice(eventName.indexOf(`:`) + 1));
    const customEvent = customEvents.find((ev) => ev.id === customEventID);
    if (customEvent) {
      name = customEvent.name;
    } else {
      throw new Error(`custom event not found for id: ${customEventID}`);
    }
  } else if (eventName === FIRST_EVENT) {
    name = `First event`;
  } else if (eventName === ANY_EVENT) {
    name = `Any event`;
  } else {
    name = renameEvent(eventName);
  }

  return name;
};

export const getHashParam = (param: string): string | null => {
  const hash = window.location.hash;
  const matches = new RegExp(`${param}=([^&]*)`).exec(hash);
  return matches ? matches[1] : null;
};

export const createPrimitiveTabData = (tab: string): object => {
  return {value: tab, label: tab, type: tab};
};

interface DataGroup {
  groupID: string;
  displayName: string;
}

export const createDataGroupTabData = (dataGroup: DataGroup): object => {
  return {
    value: dataGroup.groupID,
    label: dataGroup.displayName,
    type: ConditionTab.DataGroup,
  };
};
